import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {BinHdrModel} from '../../../../../../models/aggregates/erp/stock';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class BinHdrService extends BaseApiTemplateService<BinHdrModel> {
  //Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'bins';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'bins';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'bins';
    this.httpClient = http;
  }

}


